import { Input, OnInit, AfterViewInit, Component, ChangeDetectorRef, PLATFORM_ID, ChangeDetectionStrategy, inject } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { AnySection, NumColumns } from '../../../app/types/section';

@Component({
    imports: [],
    templateUrl: './section.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    host: {
      '[attr.kb-grid-item-columns]': 'gridItemColumns',
      '[attr.kb-next-grid-row]': 'gridNextRow',
      '[class.small-breakpoint-move-bottom]': 'smallBreakpointMoveBottom',
      '[class.small-breakpoint-reverse-order]': 'smallBreakpointReverseOrder',
    },
})
export abstract class SectionComponent<SectionType extends AnySection> implements OnInit, AfterViewInit {
  protected gridItemColumns!: NumColumns; // TODO: replace with ColumnWidth from @knorr-bremse/ngx-components once expoted
  protected gridNextRow?: 'related';
  public smallBreakpointMoveBottom?: boolean;
  public smallBreakpointReverseOrder?: boolean;

  @Input() public anchor!: string;

  @Input() public attributes!: SectionType['attributes'];
  @Input() public editorIds?: SectionType['editorIds'];

  @Input() public createSectionButton?: string;

  protected changeDetector = inject(ChangeDetectorRef);
  protected platformId = inject(PLATFORM_ID);

  public ngOnInit() {
    this.gridItemColumns = this.attributes.numColumns;
    this.gridNextRow = this.attributes.noMarginBottom === true ? 'related' : undefined;
  }

  public ngAfterViewInit() {
    if (isPlatformBrowser(this.platformId)) {
      this.changeDetector.detectChanges();
    }
  }
}
